import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCaretRight } from "@fortawesome/pro-solid-svg-icons"
import { Link } from "gatsby"
const Breadcrumbs = ({ breadcrumbs }) => (
  <section>
    <div className="relative max-w-screen-xl mx-auto px-8">
      <div className="absolute z-30 inline-block bg-primary">
        {breadcrumbs?.map((breadcrumb, index) => (
          <span key={index}>
            {index > 0 && (
              <span className="inline-block w-2 h-8 text-white">
                <FontAwesomeIcon icon={faCaretRight} size="1x" className="" />
              </span>
            )}
            <Link
              className="px-4 font-bold text-white hover:underline"
              key={index}
              to={breadcrumb.link}
            >
              {breadcrumb.link_text}
            </Link>
          </span>
        ))}
      </div>
    </div>
  </section>
)

export default Breadcrumbs
